import { render } from "./CategoryIndex.vue?vue&type=template&id=5971e17d"
import script from "./CategoryIndex.vue?vue&type=script&lang=js"
export * from "./CategoryIndex.vue?vue&type=script&lang=js"

import "./CategoryIndex.vue?vue&type=style&index=0&id=5971e17d&lang=css"

import exportComponent from "/private/tmp/claude-501/-Users-andrei-Desktop-EO-LARAVEL/7545e444-cd9b-404a-a970-150d45c9bb29/scratchpad/wt-csf-prod/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__